export default class VueRegister_serviceConfig {
	static getBaseURL() {
		return "https://cp.dzenburo.ru/";
	}
}
